import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { Worksheet, WorksheetTypeEnum } from '../types/worksheet';
import { PatchResponseBody } from '../types/api-response';
import queryClient from '../query-client';

export type UpdateWorksheetsRequest = {
    id: string;
    fields: {
        type?: WorksheetTypeEnum;
        assigned?: string[];
        code?: string;
        name?: string;
        tag?: string | null;
        description?: string | null;
        ledgerDebitTy?: number | null;
        ledgerDebitLy?: number | null;
        ledgerCreditTy?: number | null;
        ledgerCreditLy?: number | null;
        priorWorksheetId?: string;
    };
}[];

async function updateWorksheets(workpaperId: string, request: UpdateWorksheetsRequest): Promise<PatchResponseBody<Worksheet>> {
    const { data } = await api.patch(`/workpapers/${workpaperId}/worksheets`, request);
    return data;
}

export function useUpdateWorksheets(): UseMutationResult<PatchResponseBody<Worksheet>, AxiosError, UpdateWorksheetsRequest, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useMutation((req) => updateWorksheets(workpaperId, req), {
        onSettled: () => {
            queryClient.invalidateQueries(['worksheets']);
            queryClient.invalidateQueries(['other-schedules']);
            queryClient.invalidateQueries([workpaperId, 'trial-balance']);
            queryClient.invalidateQueries(['entries']);
        },
    });
}
